import axios from "@/axios";

export const namespaced = true

export const state = {
    permissions: [],
}

export const getters = {
    permissions: (state) => state.permissions
}

export const mutations = {
    SET_PERMISSIONS: (state, response) => (state.permissions.push(response.data)),
    CLEAR_PERMISSIONS: (state) => (state.permissions = []),
}

export const actions = {
    // Clear all permissions
    clearPermissions({ commit }) {
        commit('CLEAR_PERMISSIONS')
    },
    
    // Check a single permission
    //need to ensure the permissions  come with the following format:
    //{
    //    "resource": "applicationUsers",
    //    "action": "update",
    //    "data"?: { } //optional
async checkPermission({ commit }, permission) {
    commit('SET_PERMISSIONS', await axios.post(`/api/authorization/check`, permission, { config: { showToast: false } }))
  },
  
  // Check multiple permissions
  //need to ensure the permissions  come with the following format:
  //[
  //    {
  //        "resource": "applicationUsers",
  //        "action": "update",
  //        "data"?: { } //optional
  //    }
  //]
  async checkMultiplePermissions({ commit }, permissions) {
    commit('SET_PERMISSIONS', await axios.post(`/api/authorization/check-multiple`, permissions, { config: { showToast: false } }))
  }
}


//example of how to use the permissions store
// Check if user can view a specific user
// use dispatch or how ever you are calling your store
//const canViewUser = await this.$store.dispatch('permissions/checkPermission', { //
//    resource: 'applicationUsers',
//    action: 'view',
//    data: { userId: '123' }
//  });
  
  // Check multiple permissions at once
  //use dispatch or how ever you are calling your store
//  const permissions = await this.$store.dispatch('permissions/checkPermission', {
//    { resource: 'applicationUsers', action: 'view', data: { userId: '123' } },
//    { resource: 'applicationUsers', action: 'update', data: { userId: '123' } },
//    { resource: 'orders', action: 'create' }
//  ]);